import {
  GetServiceOrderIntegrationsApiResponse,
  useGetServiceCaseIntegrationsQuery,
} from '@dms/api/workshop';

interface UseIntegrationsEnabledProps {
  serviceCaseId: string;
  orderIntegrations: GetServiceOrderIntegrationsApiResponse;
}

export function useIntegrationsEnabled(props: UseIntegrationsEnabledProps) {
  const {
    data: serviceCaseIntegrations,
    isLoading: isServiceCaseIntegrationsLoading,
    isError: isServiceCaseIntegrationsError,
  } = useGetServiceCaseIntegrationsQuery({
    serviceCaseId: props.serviceCaseId,
  });

  const isClaraIntegrationEnabled = props.orderIntegrations?.orderIntegration?.some(
    (integration) => integration?.integration?.code === 'DAIMLER_CLARA'
  );
  const isDaimlerXentryIntegrationEnabled = serviceCaseIntegrations?.caseIntegration?.some(
    (integration) =>
      integration?.integration?.code === 'DAIMLER_XENTRY' ||
      integration?.integration?.code === 'MERCEDES_XENTRY'
  );
  const isEvaClaimIntegrationEnabled = serviceCaseIntegrations?.caseIntegration?.some(
    (integration) => integration?.integration?.code === 'MERCEDES_EVA'
  );

  return {
    isClaraIntegrationEnabled,
    isDaimlerXentryIntegrationEnabled,
    isEvaClaimIntegrationEnabled,
    isLoading: isServiceCaseIntegrationsLoading,
    isError: isServiceCaseIntegrationsError,
  };
}
